const PurchasedPackageButton = (props) => {
    return (
        <React.Fragment>
            <button className="anp-button purchased full-width" disabled={props.isDisabled}>{props.textButton ? props.textButton : ''}</button>
            <div className="message-text">{props.buttonMessage ? props.buttonMessage : ''}</div>
        </React.Fragment>
    )
}

export default PurchasedPackageButton;
